export default __webpack_public_path__ + "static/media/process2.35e3a714.svg";